import {useContext} from "react";
import FlowContext from "../context/FlowContext";

const Circle = ({circle, index}) => {
    const {centerObj, getDetails} = useContext(FlowContext);

    return (
        <li className="circle"
            style={{'transform': 'rotate(' + ((360 / (centerObj?.children.length)) * index) + 'deg) translateX(-143px) rotate(-' + ((360 / (centerObj?.children.length)) * index) + 'deg)'}}
            onClick={() => getDetails(circle)}>
            <div className="scroll">
                <div className="space-holder" data-pos="0"></div>
            </div>
            <div className="circle-content">
                <div className="icon"><img src={`https://fdrive.in//test-img/${circle?.img}`} alt=""/></div>
                <div className="name font-14">{circle.name}</div>
            </div>
        </li>
    )
}

export default Circle
